import React, { useEffect, useState } from 'react';
import './DecisionHistory.css';
import { API_BASE_URL } from '../config';

const DecisionHistory = ({ onUnauthorized }) => {
  const [history, setHistory] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      setError('');
      try {
        const [historyResponse, statsResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/decision/history?limit=20`, {
            credentials: 'include',
          }),
          fetch(`${API_BASE_URL}/api/decision/history/stats`, {
            credentials: 'include',
          }),
        ]);

        if (historyResponse.status === 401 || statsResponse.status === 401) {
          if (onUnauthorized) {
            onUnauthorized();
          }
          throw new Error('Sessão expirada');
        }

        if (!historyResponse.ok) {
          throw new Error('Falha ao carregar histórico');
        }

        if (!statsResponse.ok) {
          throw new Error('Falha ao carregar estatísticas');
        }

        const payload = await historyResponse.json();
        setHistory(payload.runs || []);
        setStats(await statsResponse.json());
      } catch (err) {
        setError(err.message || 'Erro ao carregar histórico');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [onUnauthorized]);

  if (loading) {
    return <div className="loading">Carregando histórico...</div>;
  }

  return (
    <div className="decision-history">
      <div className="history-header">
        <h2>Histórico de Execuções</h2>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {stats && (
        <div className="history-stats">
          <div>Total: {stats.totalRuns}</div>
          <div>EXECUTE: {stats.executeCount}</div>
          <div>AVOID: {stats.avoidCount}</div>
          <div>WATCH: {stats.watchCount}</div>
        </div>
      )}

      <table className="table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Evento</th>
            <th>Decisão</th>
            <th>Probabilidade</th>
            <th>Confiança</th>
          </tr>
        </thead>
        <tbody>
          {history.map((run) => (
            <tr key={run.id}>
              <td>{new Date(run.createdAt).toLocaleString('pt-BR')}</td>
              <td>{run.eventTitle || run.eventId}</td>
              <td>{run.decision}</td>
              <td>{(run.probabilityScore * 100).toFixed(1)}%</td>
              <td>{run.confidenceScore != null ? `${(run.confidenceScore * 100).toFixed(1)}%` : '-'}</td>
            </tr>
          ))}
          {history.length === 0 && (
            <tr>
              <td colSpan={5}>Nenhuma execução encontrada</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DecisionHistory;
